import { Drawer } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Title as UiTitle } from '@/shared/uikit/Title';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0 !important;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 72px auto 76px;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 24px;
  overflow: hidden;
  border-bottom: 1px solid ${COLORS.systemDark100};
`;

export const Body = styled.div`
  padding: 30px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow: scroll;
`;

export const Actions = styled.div`
  padding-inline: 24px;
  border-top: 1px solid ${COLORS.systemDark100};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MainActions = styled.div`
  display: flex;
  gap: 24px;
`;

export const Title = styled(UiTitle)`
  max-width: calc(100% - 32px);
  font-weight: 600;
  font-size: 22px;
  line-height: 24px;
`;
